import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { format } from "date-fns";
import { LangContext } from "../LangContext.jsx";
class MyDossierFileItem extends Component {
  static contextType = LangContext;

  render() {
    const { file, permissions, is_internal, external } = this.props;
    const { lang } = this.context;
    const extensionOrPath = file?.file?.extension ?? file?.file?.path ?? '';
    const mimes = file?.document?.mimes ?? [];
    const statusName = file?.status?.name ? lang.get('messages.' + file.status.name.toLowerCase()) : '-';
    const expirationDate = file?.personDocument?.expiration_date ?? '-';
    const fileDocumentId = file?.personDocument?.id;

    return (
      <tr>
        <td>
          <img src={"/assets/img/" + window.getMimeSVG(extensionOrPath)} />
        </td>
        <td>
          {file?.title ?? '-'}
        </td>
        <td>
          <span className="text-muted font-weight-bold">
            {mimes.length > 0
              ? mimes.map((mime, i, { length }) => (length - 1 === i ? mime.mime.toUpperCase() : mime.mime.toUpperCase() + ', '))
              : '-'}
          </span>
        </td>

        <td>{statusName}</td>
        <td>{expirationDate}</td>
        <td className="text-right">
          {fileDocumentId && external == 0 && (
            <>
              {is_internal == 1
                ? (permissions.documents_actions_internal.includes('download') || permissions.documents_actions_internal.includes('all')) && (
                    <a target="_blank" download href={"/files/" + fileDocumentId} className="btn btn-icon btn-light btn-xs mr-5">
                      <i className="flaticon2-download text-primary"></i>
                    </a>
                  )
                : (permissions.documents_actions.includes('download') || permissions.documents_actions.includes('all')) && (
                    <a target="_blank" download href={"/files/" + fileDocumentId} className="btn btn-icon btn-light btn-xs mr-5">
                      <i className="flaticon2-download text-primary"></i>
                    </a>
                  )}
            </>
          )}
          {fileDocumentId && external == 1 && (
            <>
              <a target="_blank" download href={"/files/" + fileDocumentId} className="btn btn-icon btn-light btn-xs mr-5">
                <i className="flaticon2-download text-primary"></i>
              </a>
            </>
          )}
        </td>
      </tr>
    );
  }
}

export default MyDossierFileItem;

if (document.getElementById('MyDossierFileItem')) {
    ReactDOM.render(<MyDossierFileItem />, document.getElementById('MyDossierFileItem'));
}
